import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useModalProviderContext } from '../../../../../ModalProvider';
import { mandiEditAttributesModal } from '../../../../../ModalProvider/modalNames';

import { OutlinedButton } from './styles';

const EditAttributes = ({ itemId }) => {
  const {
    setIsOpen: setMandiEditAttributesModalOpen,
  } = useModalProviderContext(mandiEditAttributesModal);

  const onEditMandiAttributes = useCallback((e) => {
    e.preventDefault();
    console.log('opening modal', { itemId });
    setMandiEditAttributesModalOpen(true, { itemId });
  }, [setMandiEditAttributesModalOpen, itemId]);

  return (
    <OutlinedButton onClick={onEditMandiAttributes}>
      Edit Window
    </OutlinedButton>
  );
};
EditAttributes.propTypes = {
  itemId: PropTypes.string.isRequired,
};
export default EditAttributes;
